import React from "react";

const GeneralLayout = ({ children }: any) => <>{children}</>;

export default GeneralLayout;
